const editorEventMixin = {
    methods: {
        /**
         * A child block has been dragged and its position and/or orderIndex has changed
         * @param $event
         */
        blockParentChanged($event) {
            this.$emit('blockParentChanged', $event);
        },
        /**
         * A child block dimensions has changed notify the parents
         * @param $event
         */
        blockDimensionsChanged($event) {
            this.$emit('blockDimensionsChanged', $event)
        },
        /**
         * A prop of a child or current block has changed
         * @param e
         */
        blockPropertyChanged(e) {
            this.$emit('blockPropertyChanged', e);
        },
        /**
         * A prop of a child or current block has changed
         * @param e
         */
        blockPositioningChanged(e) {
            this.$emit('blockPositioningChanged', e);
        },
        /**
         * A prop of a child or current block has changed
         * @param e
         */
        duplicate(e) {
            this.$emit('duplicate', e);
        },
    }
};

export default editorEventMixin;